import React, { ComponentType} from 'react';

export const ViewsPage: ComponentType = () => {

  return (
    <>
    </>
  );
};
